export default __webpack_public_path__ + "b1a3ed1fe11e4e6945a721f34bf806c2.svg";